require('./HistoryModal.scss');

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    {FlatButton} = require('material-ui'),
    HistoryModalDescription = require('./HistoryModalDescription'),
    CustomModal = require('components/Commons/CustomModal/CustomModal'),
    HistoryStore = require('stores/HistoryStore'),
    {PropTypes} = require('react'),
    HistoryModalFields = require('./HistoryModalFields'),
    Constants = require('constants/AppConstants'),
    get = require('lodash/object').get;


const HistoryModal = React.createClass({displayName: "HistoryModal",

    propTypes: {
        historySelected: PropTypes.object,
        selectedModule: PropTypes.object
    },

    _modalEl: null,

    getInitialState(){
        return {
            isVisible: false
        };
    },

    componentDidMount() {
        this.setState({
            title: t('history_modal_title_history_detail')
        });
    },

    _saveAndClose() {
        HistoryStore.saveChangeFields(() => this.close());
    },

    show() {
        this.setState({
            isVisible: true
        });
    },

    close() {
        this.setState({
            isVisible: false
        });
    },

    restore() {
        const {selectedModule, historySelected} = this.props;
        HistoryStore.restore(selectedModule, historySelected);
    },

    _getContentEl(historySelected, selectedModule) {
        return (
            React.createElement("div", {className: "bp-history-modal"}, 
                React.createElement("div", {className: "bp-history-modal__header"}, 
                    React.createElement("h4", {className: "bp-history-modal__header-title"}, t('history_modal_title_overview')), 
                    React.createElement("hr", null), 
                    React.createElement(HistoryModalDescription, {history: historySelected, selectedModule: selectedModule})
                ), 
                React.createElement("div", {className: "bp-history-modal__body"}, 
                    React.createElement("h4", {className: "bp-history-modal__body-title"}, t('history_modal_title_changes_detail')), 
                    React.createElement("hr", null), 
                    React.createElement(HistoryModalFields, {history: historySelected})
                )
            )
        );
    },

    _getActionsModal(historySelected) {
        const historyType = get(historySelected, 'type');
        switch (historyType) {
            case Constants.HISTORY_TYPE_CHANGE:
                return [
                    React.createElement(FlatButton, {
                        label: t('history_modal_button_label_cancel'), 
                        onTouchTap:  this.close
                    }
                    )
                ];
            case Constants.HISTORY_TYPE_DELETE:
                return [
                    React.createElement(FlatButton, {
                        label: t('history_modal_button_label_cancel'), 
                        onTouchTap:  this.close
                    }
                    )
                ];
            case Constants.HISTORY_TYPE_NEW:
                return [
                    React.createElement(FlatButton, {
                        label: t('history_modal_button_label_cancel'), 
                        onTouchTap:  this.close
                    }
                    )
                ];
        }
    },

    render() {
        const {historySelected, selectedModule} = this.props;

        if (!historySelected) {
            return null;
        }

        const actionsEl = this._getActionsModal(historySelected);
        const contentEl = this._getContentEl(historySelected, selectedModule);

        return (
            React.createElement(CustomModal, {
                actions: actionsEl, 
                title: this.state.title, 
                isVisible: this.state.isVisible
            }, 
                contentEl 
            )
        );
    }
});


module.exports = HistoryModal;



/** WEBPACK FOOTER **
 ** ./src/views/HistoryAdmin/HistoryModal/HistoryModal.jsx
 **/